import React from 'react';
import cx from 'classnames';
// import {Share} from 'react-twitter-widgets';
// import background from './background.png';
import githubLogo from './github.png';
import medialabLogo from './logo-medialab.svg';
import './Intro.scss';
export default function Intro() {
    return (React.createElement("div", { className: cx('Intro') },
        React.createElement("header", { className: "header" },
            React.createElement("h1", { className: "title is-1 app-logo is-title" },
                "nansi",
                React.createElement("span", { className: "tag" }, "0.0.1")),
            React.createElement("h2", { className: "title is-4 is-subtitle" }, "a lightweight network visualization tool"),
            React.createElement("div", { className: "shares" },
                React.createElement("a", { href: "https://github.com/medialab/nansi/", target: "blank", className: "github-link" },
                    React.createElement("img", { src: githubLogo })))),
        React.createElement("a", { href: "https://medialab.sciencespo.fr", target: "blank" },
            React.createElement("img", { src: medialabLogo, className: "medialab-logo" }))));
}
